// add newrelic error handling. returning true will not report the error to NR:
// https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-spa-api/set-error-handler

window.newrelic?.setErrorHandler((error: Error) => {
  // This error means that ResizeObserver was not able to deliver all
  // observations within a single animation frame. It is benign (your site
  // will not break). Check this SO for more detail:
  // https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
  if (/ResizeObserver loop/gi.test(error.message)) {
    return true
  }
  return false
})
